import { graphql, useFragment } from "react-relay";
import { TodoToolbarButtonTags_tags$key } from "./__generated__/TodoToolbarButtonTags_tags.graphql";
import { DialogButton } from "arkh";
import React from "react";
import {
  TodoTagButtonActiveContent,
  TodoTagButtonInactiveContent,
} from "./TodoTagButtonContent";

export function TodoToolbarButtonTags(props: {
  tags: TodoToolbarButtonTags_tags$key;
  onPress?: () => void;
}) {
  const tags = useFragment(
    graphql`
      fragment TodoToolbarButtonTags_tags on TodoCategoryTag
      @relay(plural: true) {
        ...TodoTagButtonContentActive_todoCategoryTag
      }
    `,
    props.tags
  );

  if (tags.length === 0) {
    return (
      <DialogButton mode="inactive" onPress={props.onPress} indicatorIcon="tag">
        <TodoTagButtonInactiveContent />
      </DialogButton>
    );
  }
  return (
    <DialogButton
      mode={props.onPress ? "active" : "locked-active"}
      onPress={props.onPress}
    >
      <TodoTagButtonActiveContent tags={tags} />
    </DialogButton>
  );
}
